import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { UpdateProjectRoleStatusRequest } from './update-project-role-status-request.model';

@Service()
export class ProjectRoleDataService {
  private readonly http = inject(HttpService);

  async updateProjectRoleStatusAsync(projectId: string, isRoleUpgraded: boolean): Promise<void> {
    const request: UpdateProjectRoleStatusRequest = { IsRoleUpgraded: isRoleUpgraded };
    await this.http.patchObjectAsync<UpdateProjectRoleStatusRequest, void>(`projects/${projectId}/role`, request);
  }
}
